import { Injectable } from '@angular/core';
import { HttpClient } from '../../../core/http/http-client';
import { ConfigService } from '../../../core/config.service';
import { Observable } from 'rxjs';
import { Response } from '@angular/http';
import { AuthenticationService } from '../../../core/auth/authentication.service';
import { LoggerService } from '../../../core/logger/logger.service';

export class Guide {
	LinkFileUrl: string;
	ContentTitle: string;
}

@Injectable()
export class GuidesService {
	private url = this.configService.baseUrl + '/api/ProgrammingGuides';
	private guides: Guide[];

	constructor(private configService: ConfigService,
	            private http: HttpClient,
	            private authService: AuthenticationService,
	            private logger: LoggerService) {
		this.authService.onLogout.subscribe(() => {
			this.guides = null;
		});
	}

	getGuides(): Observable<Guide[]> {
		if (this.guides) {
			return Observable.of(this.guides);
		} else {
			return this.loadGuides();
		}
	}

	private loadGuides(): Observable<Guide[]> {
		return this.http.get(this.url)
			.map((res: Response) => {
				this.guides = res.json();
				return this.guides;
			}).catch((err) => {
				this.logger.error(err);
				return Observable.of(null);
			});
	}
}
